// extracted by mini-css-extract-plugin
export default {"permissionsTemplatesPage":"PermissionsTemplatesPage_permissionsTemplatesPage__GF+so","header":"PermissionsTemplatesPage_header__s0Qh6"};